<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="formParam.id != '' && formParam.id != null"
          >
            Edit Product
          </h5>
          <h5 class="modal-title" v-else>Add Product</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- {{formParam}}
            {{formParamSt}} -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>
                      Brand:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="form-group">
                      <multiselect
                        v-model="selectedContact"
                        id="ajax"
                        label="brand_name"
                        track-by="id"
                        :placeholder="'Type to search Brand...'"
                        :multiple="true"
                        open-direction="bottom"
                        :custom-label="customLabel"
                        :options="contactOptions"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :close-on-select="false"
                        :options-limit="300"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="asyncFind"
                        :show-labels="false"
                      >
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <span>{{ option.name }}</span>
                            <span class="custom__remove" @click="remove(option)"
                              >❌</span
                            >
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div
                            class="multiselect__clear"
                            v-if="selectedContact.length"
                            @mousedown.prevent.stop="clearAll(props.search)"
                          ></div>
                        </template>
                        <span slot="noResult">Oops! No elements found.</span>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>
                      Name:
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formParam.name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Description:</label>
                        <div class="message-bar">
                          <div class="message-inner">
                            <div class="message-area">
                              <div class="input-group m-b-30">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="formParam.description"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending == false">
                    <!-- {{isSending}} -->
                    <button
                      @click="saveForm(0)"
                      class="btn btn-md btn-success"
                      type="button"
                    >
                      <i class="fa fa-check"></i> Save
                    </button>
                    <button
                      @click.prevent="saveForm(1)"
                      class="btn btn-md btn-info"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Save &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      isSending: false,
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      formParam: {
        copy: false,
        id: "",
        brand_id: "",
        name: "",
        description: ""
      },
      isLoading: false
    };
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(function() {
            // if (
            //   that.broadcastParam.broadcast_id != "" &&
            //   that.broadcastParam.broadcast_id != null
            // ) {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedContact = val;
            that.formParam.brand_id = val[0].id;
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedContact = val;
          this.formParam.brand_id = val[0].id;
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedContact = [];
          this.formParam.brand_id = "";
          return;
        }
      },
      deep: true
    },
    // selectedContact: {
    //   handler: function(val, oldVal) {
    //     // console.log("val.id", val.id, val.length);
    //     if (val.length > 1) {
    //       let lengthOld = oldVal.length;
    //       val.splice(0, 1);
    //       this.selectedContact = val;
    //       this.formParam.brand_id = val[0].id;
    //       // console.log('trigger',val[0].id)
    //     }
    //     if (val.length == 1) {
    //       this.formParam.brand_id = val[0].id;
    //       // console.log('triggerx',val[0].id)

    //       // this.searchData();
    //     } else {
    //       this.formParam.brand_id = "";
    //       // console.log('triggery',val[0].id)

    //       // this.searchData();
    //     }
    //   },
    //   deep: true
    // },
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            that.clearAll();
            if (that.formParamSt.id != "" && that.formParamSt.id != null) {
              if (
                typeof that.formParam.copy != "undefined" &&
                that.formParam.copy == true
              ) {
                that.formParam.id = "";
              }

              that.formParam = that.formParamSt;
              console.log("that.formParamxx", that.formParam);
              that.asyncFindSelect("", that.formParam.brand_id);
            } else {
              that.asyncFind("");
              that.formParam = {
                id: "",
                brand_id: "",
                name: "",
                description: ""
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamSt() {
      return this.$store.state.brandProduct.formParamSt;
    },
    isShowForm() {
      return this.$store.state.brandProduct.isShowForm;
    }
  },
  methods: {
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = "";
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;

          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFindSelect(query, id) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = id;

      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (id != "") {
            if (this.contactOptions.length > 0) {
              this.selectedContact = this.contactOptions[0];
            }
          }
          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          let action = "create";
          if (this.formParam.id != "") {
            action = "update";
          }
          await this.$store
            .dispatch("brandProduct/" + action, this.formParam)
            .then(response => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  id: "",
                  brand_id: "",
                  name: "",
                  description: ""
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
                this.formParam = {
                  id: "",
                  name: "",
                  description: ""
                };
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/products/form.vue